<template>
  <div class="row justify-content-center" style="">
    <div class="col-12 col-md-10 col-lg-8 col-xl-8">
      <div class="tit text-center">
        <i></i>
        <h2>Documentos</h2>
        <p>Comprovante de Residência<br>(Máximo 3 meses atrás)</p>
      </div>
      <form @submit.prevent="submit" class="text-center">
        <div class="margin">
          <files-input :files="files" :accept="acceptedFormats"
            :uploadEndpoint="uploadEndpoint" @files-changed="onFilesChanged"/>
        </div>
        <div class="text-center fixedOptions">
          <button class="btn btn-lg btn-primary">Próximo<img src="/static/assets/images/angle-right.svg"></button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import FilesInput from '@/components/FilesInput'
  import ArrayHelper from '@/utils/array-helper'

  export default {
    components: {
      FilesInput
    },
    data() {
      return {
        /* eslint-disable */  
        uploadEndpoint: process.env.API_NODE+'/files',
        acceptedFormats: 'application/pdf, image/jpeg, image/png',
        files: this.investor.ArquivosComprovanteResidencia || [null]
      }
    },
    computed: {
      receivedFiles: function() {
        return this.files.filter(file => {
          return file != null && file != undefined
        })
      }
    },
    props: {
      investor: {required: true, type: Object}
    },
    methods: {
      onFilesChanged(updatedFiles) {
        this.files = updatedFiles
      },
      removeFile(index) {
        this.files.splice(index, 1)
      },
      clearFile(index) {
        this.$set(this.files, index, null)
      },
      validate() {
        if(this.receivedFiles.length > 0) {
          return {isValid: true, errors: []}
        } else {
          return {isValid: false, errors: ['O envio do comprovante de residência é obrigatório']}
        }
      },
      submit() {
        const validation = this.validate()

        if(validation.isValid) {
          const newData = {
            ArquivosComprovanteResidencia: this.receivedFiles
          }
          this.$emit('submit', newData)
        } else {
          this.$Notify.error({
            title: "Dados Inválidos",
            message: ArrayHelper.toSentence(validation.errors)
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationInvestor/PassoEnvioComprovanteResidencia.vue